'use client';

import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AutocompleteRenderInputParams, TextField } from 'ui';

import { Customer } from '~/data';

import { usePickerCustomers } from '../../../hooks/usePickerCustomers/usePickerCustomers';
import { CustomerCountBadge } from '..';

interface Props {
  params: AutocompleteRenderInputParams;
  onChange: (customers: Customer[]) => void;
  selectedCount: number;
}

export const SearchField = ({ params, selectedCount, onChange }: Props) => {
  const { t } = useTranslation();
  const [search, setSearch] = useState('');
  const { data, isLoading } = usePickerCustomers({ filterBy: { search } });

  useEffect(() => {
    if (!isLoading && data) {
      onChange(data.items);
    }
  }, [search, isLoading, data, onChange]);

  return (
    <TextField
      {...params}
      value={search}
      placeholder={t('customerPickerLabel')}
      name="query"
      onChange={(e) => {
        setSearch(e.target.value);
      }}
      InputProps={{
        ...params.InputProps,
        startAdornment: <CustomerCountBadge count={selectedCount} />,
      }}
    />
  );
};
